import ErrorComponent from './error';

export default ErrorComponent;
